module.exports = __webpack_public_path__ + "img/tenaya-lake-2.8a786d5a.jpg";